import { PropsWithChildren, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    "data-testid"?: ReactNode;
};

export const Button = ({
    className,
    ["data-testid"]: dataTestId,
    variant,
    children,
    ...props
}: PropsWithChildren<
    ButtonProps & { variant?: "default" | "primary" | "secondary" | "subtle" }
>) => {
    return (
        <button
            {...props}
            data-testid={dataTestId || children}
            className={twMerge(
                "cursor-pointer rounded px-3 py-1.5 font-bold disabled:cursor-default disabled:opacity-30",
                "transition duration-100 ease-in-out [&:not(:disabled)]:active:scale-95 [&:not(:disabled)]:active:shadow-inner",
                variant === "default" &&
                    "border-2 border-black bg-white text-black [&:not(:disabled)]:hover:bg-gray-200 [&:not(:disabled)]:active:bg-gray-200",
                variant === "primary" &&
                    "bg-button-primary-background text-button-primary-foreground [&:not(:disabled)]:hover:bg-button-primary-hover [&:not(:disabled)]:active:bg-button-primary-hover",
                variant === "secondary" &&
                    "border-2 border-button-secondary-foreground bg-button-secondary-background text-button-secondary-foreground [&:not(:disabled)]:hover:text-button-primary-hover [&:not(:disabled)]:active:text-button-primary-hover",
                variant === "subtle" &&
                    "border-2 border-button-subtle-border bg-button-subtle-background text-button-subtle-foreground [&:not(:disabled)]:hover:text-button-subtle-hover [&:not(:disabled)]:active:text-button-subtle-hover",
                className
            )}
        >
            {children}
        </button>
    );
};
